import { render } from "./AttachmentIcon.vue?vue&type=template&id=2f363cd5"
import script from "./AttachmentIcon.vue?vue&type=script&lang=js"
export * from "./AttachmentIcon.vue?vue&type=script&lang=js"
script.render = render

export default script